import type { BriefTemplateListStatusFilter, ListBriefTemplatesQuery } from '@fluenceur/types';

/** Base path for every brief-template endpoint. */
export const BRIEF_TEMPLATES_PATH = '/dashboard/collabs/brief-templates';

interface BriefTemplateListParams {
  search: string;
  status: BriefTemplateListStatusFilter;
  /** Absent lists every type. */
  collabType?: ListBriefTemplatesQuery['collabType'];
}

/**
 * Query-key factory for collab brief templates. Keyed on brand so each brand
 * caches independently; the list adds the search, status and type filters so a filter
 * change refetches its own server-filtered page while the detail cache stays
 * addressable by template id (that entry is what autosave patches in place).
 */
export const briefTemplateKeys = {
  all: (brandId: string) => ['briefTemplates', brandId] as const,
  /** Every list page of a brand, whatever its filter; never matches a detail entry. */
  lists: (brandId: string) => ['briefTemplates', brandId, 'list'] as const,
  list: (brandId: string, params: BriefTemplateListParams) =>
    [
      'briefTemplates',
      brandId,
      'list',
      params.search,
      params.status,
      params.collabType ?? 'all',
    ] as const,
  detail: (brandId: string, templateId: string) =>
    ['briefTemplates', brandId, 'detail', templateId] as const,
  /** Every page of one brief's proposed creators; a sent proposal refreshes them all. */
  proposedCreators: (brandId: string, templateId: string) =>
    ['briefTemplates', brandId, 'proposed-creators', templateId] as const,
};
